import Section from '../components/Section';
import { useLanguage } from '../context/LanguageContext';

export default function LegalPage({ title }) {
  const { t } = useLanguage();
  return (
    <Section title={title}>
      <div className="article">
        <div className="article__disclaimer" style={{ '--disclaimer-dot': 'var(--accent)' }}>
          <strong>Being finalised.</strong> {t('legal.pending')}
        </div>
        <p className="mt-3 muted">
          For any query in the meantime, contact <a href="mailto:admin@napho.in">admin@napho.in</a>.
        </p>
      </div>
    </Section>
  );
}
